var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        width: "500px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { "label-width": "90px", model: _vm.form, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "原密码", prop: "oldPassword" } },
            [
              _c("el-input", {
                attrs: {
                  "show-password": "",
                  placeholder: "请输入原密码",
                  clearable: ""
                },
                model: {
                  value: _vm.form.oldPassword,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "oldPassword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.oldPassword"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "新密码", prop: "newPassword" } },
            [
              _c("el-input", {
                attrs: {
                  "show-password": "",
                  placeholder: "请输入新密码",
                  clearable: ""
                },
                model: {
                  value: _vm.form.newPassword,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "newPassword",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.newPassword"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "确认新密码", prop: "Password" } },
            [
              _c("el-input", {
                attrs: {
                  "show-password": "",
                  placeholder: "请再次输入新密码",
                  clearable: ""
                },
                model: {
                  value: _vm.form.Password,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "Password",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.Password"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }